var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSociallink2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    stroke: "#282D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.402V20.1875C8.5 21.0329 8.83583 21.8436 9.4336 22.4414C10.0314 23.0392 10.8421 23.375 11.6875 23.375H22.3125C23.1579 23.375 23.9686 23.0392 24.5664 22.4414C25.1642 21.8436 25.5 21.0329 25.5 20.1875V15.402L17.4356 19.0315C17.2986 19.0931 17.1502 19.1249 17 19.1249C16.8498 19.1249 16.7014 19.0931 16.5644 19.0315L8.5 15.402ZM8.57862 13.107L17 16.898L25.4214 13.107C25.2614 12.4021 24.8666 11.7725 24.3017 11.3215C23.7368 10.8705 23.0353 10.6249 22.3125 10.625H11.6875C10.9647 10.6249 10.2632 10.8705 9.69835 11.3215C9.13345 11.7725 8.73861 12.4021 8.57862 13.107Z",
    fill: "#007CC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociallink2);
export default __webpack_public_path__ + "static/media/social link (2).478a23660b49fabcdfde0706c4b872ba.svg";
export { ForwardRef as ReactComponent };